import {useState} from 'react';
import {ChangePasswordPanel} from './ChangePasswordPanel';
import {ECFS_OFFICIAL_ICON} from '../assets/officialLogo';

/** ECFS-branded FloatHelm top-right account menu.
 * Unsupported destinations are explicitly disabled, never redirected to an
 * unrelated page or presented as fake working screens.
 */
export function StaffAccountMenu({
  onGoCalendar,onGoAvailability,onGoTimesheet,onSignOut,theme,onThemeChange,
  onHelpFeedback,
}:{onGoCalendar:()=>void;
  onGoAvailability:()=>void;onGoTimesheet:()=>void;
  onHelpFeedback:()=>void;
  theme:'light'|'dark';onThemeChange:(next:'light'|'dark')=>void;
  onSignOut:()=>Promise<void>;
  onGoPublic?:()=>void;canManageTeam?:boolean;automaticBulkStatus?:string;}){
  const [open,setOpen]=useState(false);
  const [busy,setBusy]=useState(false);
  const [error,setError]=useState('');
  const notConnected=['My Preferences'];
  return <div className="ecfs-account-anchor">
    <button type="button" className="ecfs-account-logo-button"
      aria-label="Account settings menu" aria-haspopup="menu" aria-expanded={open}
      onClick={()=>setOpen(v=>!v)}><img src={ECFS_OFFICIAL_ICON} alt=""/></button>
    {open&&<div role="menu" className="ecfs-account-menu" aria-label="My Account">
      <button type="button" role="menuitem" onClick={()=>{
        setOpen(false);onGoCalendar();
      }}>My Calendar</button>
      <button type="button" role="menuitem" onClick={()=>{
        setOpen(false);onGoAvailability();}}>My Availability</button>
      <button type="button" role="menuitem" onClick={()=>{
        setOpen(false);onGoTimesheet();}}>My Timesheet</button>
      {notConnected.map(label=><button type="button" role="menuitem"
        disabled key={label}
        title={label+' is not connected to the owner-approved data source yet'}>
        {label}</button>)}
      <div className="ecfs-account-menu-rule"/>
      <button type="button" role="menuitem" aria-label="Toggle light and dark mode"
        onClick={()=>onThemeChange(theme==='light'?'dark':'light')}>
        Appearance: {theme==='light'?'Light Mode':'Dark Mode'} (switch to {theme==='light'?'Dark':'Light'})
      </button>
      <ChangePasswordPanel/>
      <button type="button" role="menuitem" disabled={busy} onClick={()=>{
        setBusy(true);setError('');
        void onSignOut().then(()=>setOpen(false)).catch(e=>{
          setError(e instanceof Error?e.message:'Logout unavailable.');
        }).finally(()=>setBusy(false));
      }}>{busy?'Logging out…':'Logout'}</button>
      <button type="button" role="menuitem" disabled
        title="A separate mobile view is not yet implemented.">Mobile Mode</button>
      <div className="ecfs-account-menu-rule"/>
      {['Shortcuts',"What's New?"].map(label=><button type="button"
        key={label} role="menuitem" disabled
        title="This feature has not yet been connected.">{label}</button>)}
      <button type="button" role="menuitem" className="ecfs-account-help"
        onClick={()=>{setOpen(false);onHelpFeedback();}}>
        Help &amp; Feedback</button>
      {error&&<p role="alert">{error}</p>}
    </div>}
  </div>;
}
